<template>
    <div class=" row pt-4" v-if="pois.length">
        <div class="mr-5 ml-5">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-4 d-flex pois-item">
                <div v-for="poisItem in pois" :key="poisItem.name" class="mr-5  passes-card">
                    <a :href="poisItem.link" target="_blank">
                        <div class="card passes-card ">
                            <div class="card-body mx-auto d-flex ">
                                <div class="row ">
                                    <svg-icon aria-label="icon" :name="poisItem.type" width="50" height="auto"></svg-icon>
                                    <span class="badge">{{poisItem.count}}</span>
                                </div>
                            </div>
                        </div>
                    </a>
                <h3 class="text-center"> {{poisItem.name}}</h3>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { mapState } from 'vuex'

export default {
    props: {
        journeyType: {
            type: String,
            default: 'depart',
        },
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapState([
            'currentJourney',
        ]),
        pois() {
            return this.currentJourney[this.journeyType].pois
        },

    },
}
</script>
